<template>
  <div class="">
    <div class="container column sign-in--content container align-items-center justify-content-center hidden">
      <div class="sign-in--content__box animation-bottom">
        <div class="sign-in--content__box--header">
          <div class="sign-in--content__box--header__logo container align-items-center justify-content-center">
            <div class="jet" :class="{ animationJet : animaJet}">
              <img src="@/assets/img/logos/jet.svg" alt="Minds">
            </div>
            <img src="@/assets/img/logos/logo-login.svg" class="logo" alt="Minds">
          </div>
        </div>
        <div class="sign-in--content__box--content">
          <form role="form" class="full-width" @submit.prevent="validateBeforeSubmit(form)">
            <div class="sign-in--content__box--content--limit">
              <div class="block-input animation-fade animation-delay-02">
                <div class="input-space input-space-special container align-items-center" style="background: rgb(209, 137, 148); color: rgb(255, 255, 255);">
                  <div class="icons">
                    <img aria-hidden="true" src="@/assets/img/boylogin.svg" class="" alt="star" height="20">
                  </div>
                  <input type="email" name="email" class="input input-big" v-validate="'required|email'" required autofocus placeholder="usuario@email.com" v-model="form.email" :disabled="isLoading">
                </div>
                <div v-show="errors.has('email')" class="help-block" v-cloak>
                  <span>
                    <small>{{ errors.first('email') }}</small>
                  </span>
                </div>
              </div>
              <div class="block-input animation-fade animation-delay-03">
                <div class="input-space input-space-special container align-items-center" style="background: rgb(209, 137, 148); color: rgb(255, 255, 255);">
                  <div class="icons">
                    <img aria-hidden="true" src="@/assets/img/locklogin.svg" class="" alt="star" height="22">
                  </div>
                  <input type="password" name="password" class="input input-big" v-validate="'required'" required autofocus placeholder="senha" v-model="form.password" :disabled="isLoading">
                </div>
                <div v-show="errors.has('password')" class="help-block" v-cloak>
                  <span>
                      <small>{{ errors.first('password') }}</small>
                  </span>
                </div>
              </div>
              <div class="block-input" :style="{ visibility: tried ? 'visible' : 'hidden' }">
                <div class="input-space input-space-special container align-items-center error-login" style="background: rgb(209, 137, 148);">
                  <span>{{ message }}</span>
                </div>
              </div>
              <div class="input-space-btns container align-items-center animation-fade animation-delay-05 btn-full">
                <button type="submit" name="button" class="btn btn-rounded btn-blue-soft btn-full btn-shadow" :disabled="isLoading">ENTRAR</button>
                <i v-show="isLoading" class="fa fa-spinner fa-spin"></i>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="powered container align-items-center animation-bottom animation-delay-1">
        <span class="">Powered by</span>
        <img class="by" src="@/assets/img/logos/minds-white.svg" width="75" alt="Minds">
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import inputComponent from '@/components/input'

export default {
  data () {
    return {
      formError: null,
      form: {
        email: '',
        password: ''
      },
      loading: false,
      isLoading: false,
      checked: true,
      animaJet: false,
      tried: false,
      message: ''
    }
  },
  components: {
    inputComponent
  },
  computed: {
    ...mapGetters({
      hasError: 'hasError',
      error: 'getError'
    })
  },
  methods: {
    animationJet () {
      this.animaJet = !this.animaJet
    },
    validateBeforeSubmit (teacher) {
      if (this.tried) this.tried = false
      this.isLoading = true
      this.$validator.validateAll().then(async x => {
        await this.$store.dispatch('auth/teacherLogin', teacher)
        this.animationJet()
      }).catch(error => {
        if (error.code == 'auth/too-many-requests') this.message = 'Try again later'
        else this.message = 'Incorrect Username or Password'
        this.tried = true
        this.isLoading = false
        // alert(error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import './src/assets/css/components/login.scss';
</style>



// WEBPACK FOOTER //
// src/pages/auth/teacher-login.vue